export default {
      id: "arrow-right-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "img/icons.31feac93.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }